export default {"src":"/_next/static/media/et.eb442fe6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};